var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTodayIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6669 14.6666H9.33351V13.3333H6.66679V14.6666H5.33343C4.96542 14.6666 4.66675 14.9653 4.66675 15.3333C4.66675 15.7013 4.96542 16 5.33343 16H10.6669C11.0355 16 11.3336 15.7013 11.3336 15.3333C11.3336 14.9653 11.0355 14.6666 10.6669 14.6666Z",
    fill: "#3030AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8336 2.6664H11.2336C11.3002 2.97974 11.3336 3.30641 11.3336 3.62642V3.99976H14.667V11.9999H1.33336V3.99976H4.66676V3.62642C4.66676 3.30641 4.7001 2.97974 4.76677 2.6664H1.16669C0.526678 2.6664 0 3.19307 0 3.83309V12.1666C0 12.8066 0.526678 13.3333 1.16669 13.3333H14.8336C15.4737 13.3333 16.0003 12.8066 16.0003 12.1666V3.83309C16.0003 3.19307 15.4737 2.6664 14.8336 2.6664Z",
    fill: "#3030AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 8.65918H5.00009C4.81608 8.65918 4.66675 8.50984 4.66675 8.32584V7.54516C4.66675 7.09981 4.84008 6.68114 5.15476 6.36647L6.00011 5.52111V3.62641C6.00011 2.82173 6.27011 2.02771 6.76079 1.39036L7.73615 0.123003C7.86215 -0.0410009 8.13882 -0.0410009 8.26482 0.123003L9.24018 1.39103C9.73019 2.02771 10.0002 2.82173 10.0002 3.62641V5.52111L10.8455 6.36647C11.1602 6.68114 11.3336 7.09981 11.3336 7.54516V8.32584C11.3336 8.51051 11.1842 8.65918 11.0002 8.65918Z",
    fill: "#3030AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66686 9.99253C9.29819 9.99253 9.00018 9.69386 9.00018 9.32585V8.32583C9.00018 7.95782 9.29819 7.65915 9.66686 7.65915C10.0355 7.65915 10.3335 7.95782 10.3335 8.32583V9.32585C10.3335 9.69452 10.0355 9.99253 9.66686 9.99253Z",
    fill: "#3030AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33349 9.99253C5.96482 9.99253 5.66681 9.69386 5.66681 9.32585V8.32583C5.66681 7.95782 5.96482 7.65915 6.33349 7.65915C6.70216 7.65915 7.00017 7.95782 7.00017 8.32583V9.32585C7.00017 9.69452 6.70216 9.99253 6.33349 9.99253Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTodayIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/todayIcon.859c17b703e39670e1040fb7f51b74c6.svg";